module.exports = __webpack_public_path__ + "static/media/nin.e708f235.png";